function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Icon } from '../../../../components/icon';
export var IconInfoCircle = props => {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 0A10 10 0 0 0 0 10c0 5.522 4.477 10 10 10s10-4.478 10-10S15.522 0 10 0m1 15H9V9h2v6zm0-8H9V5h2",
    id: "info-circle"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 1 0 0 16c4.418 0 8-3.582 8-8a8 8 0 0 0-8-8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "info-circle-mask",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#info-circle"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0360a6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#info-circle"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#info-circle-mask)",
    d: "M0 0h20v20H0z"
  }))));
};